import { render } from "./SignupFormLanding.vue?vue&type=template&id=248e0b56&scoped=true"
import script from "./SignupFormLanding.vue?vue&type=script&lang=js"
export * from "./SignupFormLanding.vue?vue&type=script&lang=js"

import "./SignupFormLanding.vue?vue&type=style&index=0&id=248e0b56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248e0b56"]])

export default __exports__